import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { postMailSecurityVerifyCp2 } from '@/api/accountEndpoint';
import { MailSecurityVerifyDetail, MailSecurityVerifyResponse } from '@/types/emailSerurity';
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'MailSecurityVerifyView',
  setup(__props) {

const router = useRouter();
const route = useRoute();

onMounted(async () => {
  const mailAuthKey = (route?.params?.mailAuthKey ?? '') as string;
  if (!mailAuthKey) {
    router.replace({name: 'cp2mss09'});
    return;
  }
  try {
    const res = await postMailSecurityVerifyCp2(mailAuthKey) as MailSecurityVerifyResponse;
    const resDetail = res?.detail as MailSecurityVerifyDetail;
    // Redirect to Error Page if detail is missing (e.g. DB update failure)
    if (!resDetail) {
      router.replace({ name: 'cp2mss09' });
      return;
    }
    
    if (resDetail.isRegisteredMypage) {
      localStorage.removeItem('mailSecurityUpdateInfo');
      await router.replace({ name: 'verify-mypage-password', params: { mailAuthKey } });
      return;
    }
    
    // Redirect to Verify Expire Page
    if (resDetail?.isKeyExpired) {
      router.replace({
        name: 'cp2mss071'
      });
      return;
    }

    if (resDetail?.isNotExistsKey || resDetail?.isAlreadyAuthen) {
      // Redirect to Verify Error Page
      router.replace({
        name: 'cp2mss09'
      });
      return;
    }
    localStorage.removeItem('mailSecurityUpdateInfo');
    // Redirect to Success Page Verify Success
    router.replace({
      name: 'cp2-complete-registration-success',
      query: {
        email: resDetail?.email
      }
    });
  } catch (e) {
    // Redirect to Error Verify Page
    router.replace({
      name: 'cp2mss09'
    });
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span"))
}
}

})